var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5349L8.413 14.5199L18.045 4.97988C18.423 4.60188 18.631 4.09988 18.631 3.56588C18.631 3.03188 18.423 2.52988 18.045 2.15188L16.459 0.565875C15.703 -0.190125 14.384 -0.186125 13.634 0.562875L4 10.1049V14.5349ZM15.045 1.97988L16.634 3.56288L15.037 5.14488L13.451 3.55988L15.045 1.97988ZM6 10.9389L12.03 4.96588L13.616 6.55188L7.587 12.5229L6 12.5279V10.9389Z",
    fill: "#704DE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5215H16C17.103 18.5215 18 17.6245 18 16.5215V7.85348L16 9.85348V16.5215H5.158C5.132 16.5215 5.105 16.5315 5.079 16.5315C5.046 16.5315 5.013 16.5225 4.979 16.5215H2V2.52148H8.847L10.847 0.521484H2C0.897 0.521484 0 1.41848 0 2.52148V16.5215C0 17.6245 0.897 18.5215 2 18.5215Z",
    fill: "#704DE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e5c1d1747373491ef57975f722e05ad2.svg";
export { ForwardRef as ReactComponent };